import React, { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  addCanvasSlide,
  duplicateCanvasSlide,
  goToSlide,
  removeCanvasSlide,
  updateSlideInfo,
} from "../../../thunks/editor/canvasThunks";
import { Dropdown } from "../../common/dropdown";
import { setCurrentSlideIndex } from "../../../store/slides/slidesSlice";
import { CanvasContext } from "../CanvasContext";

const SlideDropdown = ({
  className,
  slideIndex,
  disabled,
  handleSlideMenu,
}) => {
  const dispatch = useDispatch();
  const { canvas } = useContext(CanvasContext);
  const trial = useSelector((state) => state?.user?.details?.data?.trial);

  const { slides, currentSlideIndex } = useSelector((state) => state.slides);

  const onlySingleSlide = useMemo(() => (slides || []).length === 1, [slides]);

  const slidesWithAvatarDId = slides.filter((slide) => {
    // Check if the slide has objects and any of them is an avatar with a URL including "d-id"
    return (
      slide.objects &&
      slide.objects.some((obj) => {
        return obj.type === "avatar" && obj.url.includes("d-id");
      })
    );
  });

  const shouldDisplayOneSlide = slidesWithAvatarDId.length >= 3;

  const handleTransition = (value) => {
    const transitionData = value ? { name: value, duration: 300 } : null;
    return dispatch(updateSlideInfo({ transitionData }));
  };
  const handleDelete = (index) => {
    if (currentSlideIndex === index) {
      let nextIndex = index - 1;
      if (index === 1) {
        nextIndex = 2;
      }

      canvas.clear();
      canvas.setBackgroundColor("white", canvas.renderAll.bind(canvas));
      dispatch(goToSlide(nextIndex, canvas));
    }
    handleSlideMenu();
    return dispatch(removeCanvasSlide(index));
  };

  const slideMenu = useMemo(
    () => [
      {
        title: "Edit Transition",
        onClick: handleTransition,
        icon: "/tool/dashboard/static/images/icons/tools/transition.svg",
        items: [
          {
            title: "None",
            icon: "/tool/dashboard/static/images/icons/tools/none.svg",
          },
          {
            title: "Fade",
            icon: "/tool/dashboard/static/images/icons/tools/fade.svg",
            value: "FADE",
          },
          {
            title: "Left",
            icon: "/tool/dashboard/static/images/icons/tools/left.svg",
            value: "WIPE_LEFT",
          },
          {
            title: "Right",
            icon: "/tool/dashboard/static/images/icons/tools/right.svg",
            value: "WIPE_RIGHT",
          },
          {
            title: "Down",
            icon: "/tool/dashboard/static/images/icons/tools/down.svg",
            value: "WIPE_DOWN",
          },
          {
            title: "Up",
            icon: "/tool/dashboard/static/images/icons/tools/up.svg",
            value: "WIPE_UP",
          },
        ],
        isDisabled: onlySingleSlide,
      },
      {
        title: "Add Slide",
        onClick: () => dispatch(addCanvasSlide(slideIndex)),
        icon: "/tool/dashboard/static/images/icons/tools/rounded-add.svg",
        isDisabled:
          shouldDisplayOneSlide || trial
            ? slides.length >= 3
            : slides.length >= 10,
      },
      {
        title: "Duplicate",
        onClick: () => dispatch(duplicateCanvasSlide(slideIndex)),
        icon: "/tool/dashboard/static/images/icons/tools/duplicate.svg",
        isDisabled:
          shouldDisplayOneSlide || trial
            ? slides.length >= 3
            : slides.length >= 10,
      },
      // {
      //   title: "Import PPT/PDF",
      //   onClick: () => {},
      //   icon: "/tool/dashboard/static/images/icons/tools/import.svg",
      // },
      {
        title: "Delete",
        onClick: () => handleDelete(slideIndex),
        icon: "/tool/dashboard/static/images/icons/tools/delete.svg",
        isDisabled: onlySingleSlide,
      },
    ],
    [slides]
  );
  return (
    <Dropdown menu={slideMenu} className={className} disabled={disabled} />
  );
};

export default SlideDropdown;
